
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Strings`}</h1>
<p>{`Use single quotes `}<inlineCode parentName="p">{`' '`}</inlineCode>{` for strings.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const name = "User";

// Good
const name = 'User';
`}</code></pre>
<p>{`Only use back quotes \`\`\`\` when there are variables to interpolate.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const name = \`User\`;

// Good
const name = \`The name is: \${name}\`;
`}</code></pre>
<p>{`When variables need to be added to an string, don't use concatenation, always use string templates.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const string = 'The name is: ' + name;

// Good
const string = \`The name is: \${name}\`;
`}</code></pre>
<p>{`When spliting long strings, don't use back quotes, they keep the indentation. Instead, concatenate them.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
function myFunction() {
  const text = \`Lorem ipsum dolor sit amet, consectetur adipiscing elit.
    Morbi convallis elit erat, quis faucibus metus gravida a. Quisque ac velit
    eu nibh ultricies malesuada venenatis vitae magna.\`;
  // ... more code ...
}

// Good
function myFunction() {
  const text = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. ' +
    'Morbi convallis elit erat, quis faucibus metus gravida a. Quisque ac velit ' +
    'eu nibh ultricies malesuada venenatis vitae magna.';
  // ... more code ...
}
`}</code></pre>
<p>{`Avoid escaping unnecessary characters. When single quotes need to be used inside a string, use back quotes instead.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const string = 'It\\'s a me, Mario!';

// Good
const string = \`It's a me, Mario!\`;
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;